import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { MODAL_DATA, MODAL_REF, ModalRef } from '@services/components/ModalService/modal.ref';

import { CHILEXPRESS_TRACKING_CODE_MAX_LENGTH, CHILEXPRESS_TRACKING_CODE_PATTERN } from '@constants/orders.constants';

export interface ShipOrderModalData {
  orderCode: string;
  /** false cuando el pago del pedido todavía no está confirmado. */
  isPaid: boolean;
}

@Component({
  selector: 'app-ship-order-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './ship-order-modal.component.html',
  styleUrl: './ship-order-modal.component.css',
})
export class ShipOrderModalComponent {
  private readonly modalRef = inject(MODAL_REF) as ModalRef<string>;
  private readonly data = inject<ShipOrderModalData>(MODAL_DATA);
  private readonly fb = inject(FormBuilder);

  protected readonly orderCode = this.data?.orderCode ?? '';
  protected readonly isPaid = this.data?.isPaid ?? true;

  public readonly form = this.fb.nonNullable.group({
    trackingCode: ['', [Validators.required, Validators.maxLength(CHILEXPRESS_TRACKING_CODE_MAX_LENGTH), Validators.pattern(CHILEXPRESS_TRACKING_CODE_PATTERN)]],
  });

  protected get trackingCodeInvalid(): boolean {
    const ctrl = this.form.controls.trackingCode;
    return ctrl.invalid && (ctrl.touched || ctrl.dirty);
  }

  public onCancel(): void {
    this.modalRef.close({ reason: 'cancel' });
  }

  public onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { trackingCode } = this.form.getRawValue();
    this.modalRef.close({ reason: 'confirm', data: trackingCode.trim() });
  }
}
